var rgbaToRgba = function (rgba, a) {
    var parts = rgba.split(',');
    parts[3] = " " + a + ")";
    return parts.join(',');
};
var rgbToRgba = function (rgb, a) {
    return rgb.replace(')', ", " + a + ")").replace('rgb', 'rgba');
};
var hexToRgba = function (hex, a) {
    var r = parseInt(hex.substring(1, 3), 16);
    var g = parseInt(hex.substring(3, 5), 16);
    var b = parseInt(hex.substring(5, 7), 16);
    return "rgba(" + r + ", " + g + ", " + b + ", " + a + ")";
};
export var calculateColor = function (color, opacity) {
    if (color.includes('rgba')) {
        return rgbaToRgba(color, opacity);
    }
    if (color.includes('rgb')) {
        return rgbToRgba(color, opacity);
    }
    return hexToRgba(color, opacity);
};
//# sourceMappingURL=color.js.map